import { Alert, Box, Container, Stack, styled } from '@mui/material';
import gradientPricingPage from '../../assets/images/gradientPricingPage.png';

export const StyledContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: theme.spacing(3),
  gap: theme.spacing(3),
  [theme.breakpoints.down('desktop')]: {
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));
StyledContainer.defaultProps = {
  maxWidth: 'lg',
};

export const StyledOuterCointainer = styled(Stack)(({ theme }) => ({
  height: '100vh',
  backgroundImage: `url(${gradientPricingPage})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100% auto',
  gap: theme.spacing(2),
  padding: theme.spacing(3, 0),
  [theme.breakpoints.down('desktop')]: {
    padding: theme.spacing(2, 0),
  },
  [theme.breakpoints.down('sm')]: {
    backgroundSize: '100% 50%',
  },
}));

export const StyledLoadingContainer = styled(Container)({
  display: 'flex',
  justifyContent: 'center',
});

export const StyledAlert = styled(Alert)({});
StyledAlert.defaultProps = {
  variant: 'outlined',
  severity: 'error',
  color: 'error',
};

export const StyledSwitchWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const StyledPricingBoxesContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(3),
  gridTemplateColumns: 'repeat(3, 1fr)',
  width: '100%',
  [theme.breakpoints.down('desktop')]: {
    gridTemplateColumns: '1fr',
    justifyItems: 'center',
    gap: theme.spacing(2),
  },
}));
